/* eslint-disable camelcase */
import React from "react";
import { bool, array, string } from "prop-types";
import { OtherStory } from "./OtherStory";

import "./three-col-nine-stories-var-one-with-bg.m.css";

export const SecondColumn = ({ stories, show_story_separator, show_timestamp, show_read_time, sectionSlug }) => {
  if (stories.length < 1) {
    return null;
  }

  return (
    <div styleName="second-column">
      {stories.map(({ story, id }, index) => (
        <OtherStory
          key={id}
          story={story}
          showSeparator={show_story_separator}
          defaultFallback={false}
          showTimestamp={show_timestamp}
          showReadTime={show_read_time}
          showThumbnail={index === 0}
          sectionSlug={sectionSlug}
        />
      ))}
    </div>
  );
};

SecondColumn.propTypes = {
  stories: array,
  show_story_separator: bool,
  show_timestamp: bool,
  show_read_time: bool,
  sectionSlug: string,
};
